export enum eRecordingParty {
  Spruce = 'spruce',
  ZillowClosing = 'zillow-closing',
  Lender = 'lender',
}
